import React, {useContext, useEffect, useState} from "react";

import {log} from "../../ApiCalls";

import "../../../../style/PriorityTableStyles/actionButton.css";

import {ActionButtonModeEnum} from "../../../../Types/ActionButtonMode"
import {StatusEnum} from "../../../../Types/StatusEnum";
import {RolesEnum} from "../../../../Types/RolesEnum";
import SetToReviewModal from "./SetToReviewModal";
import RevisionModal from "./RevisionModal";
import ContentEditorApproveModal from "./ContentEditorApproveModal";
import {TaskType} from "../../../../Types/Task";
import {azureTokenContext, userIdContext} from "../../../../App";

export default function ActionButton({task, setAllTasks, setSelectedTasks}: {
    task: TaskType,
    setAllTasks: React.Dispatch<React.SetStateAction<TaskType[]>>,
    setSelectedTasks: React.Dispatch<React.SetStateAction<TaskType[]>>
}) {
    const userId = useContext(userIdContext);
    const azureToken = useContext(azureTokenContext);

    const [buttonMode, setButtonMode] = useState<ActionButtonModeEnum>(ActionButtonModeEnum.none);
    const [isSetToReviewModalOpen, setIsSetToReviewModalOpen] = useState(false);
    const [isContentEditorApproveModalOpen, setIsContentEditorApproveModalOpen] = useState(false);
    const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);

    useEffect(() => {
        if (!task.WorkItemId && !task.AuthorCreatedWI) {
            setButtonMode(ActionButtonModeEnum.update)
        } else if (task.Status === StatusEnum.init && task.Role === RolesEnum.author) {
            setButtonMode(ActionButtonModeEnum.setToReview)
        } else if (task.Status === StatusEnum.init && task.Role === RolesEnum.contentEditor && task.AuthorEmail) {
            setButtonMode(ActionButtonModeEnum.emailToAuthor)
        } else if (task.Status === StatusEnum.readyForReview && task.Role === RolesEnum.contentEditor && !task.GotApprovalFromContentReviewer) {
            setButtonMode(ActionButtonModeEnum.contentEditorApprove)
        } else {
            setButtonMode(ActionButtonModeEnum.none)
        }

    }, [task.Role, task.Status, task.WorkItemId, task.AuthorEmail, task.GotApprovalFromContentReviewer, task.AuthorCreatedWI]);

    const mailtoAuthorLink = () => {
        const authorEmail = task.AuthorEmail;
        const subject = encodeURIComponent("Vennlig påminnelse: handling nødvendig for manuskriptet ditt");
        const body = encodeURIComponent(`Hei ${task.Author || "forfatter"},\n\nDette er en vennlig påminnelse om å følge opp manuskriptet til "${task.TaskName}" i Authors Portal og fullføre eventuelle åpne oppgaver. Ta gjerne kontakt hvis du trenger hjelp.\n\nVennlig hilsen\nFagredaktør`);
        return `mailto:${authorEmail}?subject=${subject}&body=${body}`;
    }

    return (
        <div className="action-button-container">
            {buttonMode === ActionButtonModeEnum.none && <></>}
            {buttonMode === ActionButtonModeEnum.update &&
                <>
                    {task.Role === RolesEnum.author && (
                        <button
                            className="action-button"
                            onClick={() => setIsRevisionModalOpen(true)}
                        >
                            Oppdater
                        </button>
                    )}
                </>
            }
            {buttonMode === ActionButtonModeEnum.setToReview &&
                <button className="action-button" onClick={() => setIsSetToReviewModalOpen(true)}>Sett til
                    vurdering</button>
            }
            {buttonMode === ActionButtonModeEnum.contentEditorApprove &&
                <button className="action-button" onClick={() => setIsContentEditorApproveModalOpen(true)}>Godkjenn
                    manus</button>
            }
            {buttonMode === ActionButtonModeEnum.emailToAuthor &&
                <a href={mailtoAuthorLink()}
                   onClick={() => log("INFO", `ContentEditor clicked on email to author button for WorkItemId: ${task.WorkItemId}`, "AuthorsPortal", task.WorkItemId, "ContentEditor", userId, azureToken)}>
                    <button className="action-button">Purre på forfatter</button>
                </a>
            }

            <SetToReviewModal isOpen={isSetToReviewModalOpen}
                              setIsOpen={setIsSetToReviewModalOpen}
                              task={task}
                              setAllTasks={setAllTasks}
                              setSelectedTasks={setSelectedTasks}
            />
            <ContentEditorApproveModal isOpen={isContentEditorApproveModalOpen}
                                       setIsOpen={setIsContentEditorApproveModalOpen}
                                       task={task}
                                       setAllTasks={setAllTasks}
                                       setSelectedTasks={setSelectedTasks}
            />

            <RevisionModal
                isOpen={isRevisionModalOpen}
                setIsOpen={setIsRevisionModalOpen}
                task={task}
                setAllTasks={setAllTasks}
                setSelectedTasks={setSelectedTasks}
            />
        </div>
    );

}
